import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Event, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { includes } from 'ramda';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'pulse-sidebar',
  host: { class: 'pulse-sidebar' },
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  activeRoute = '';
  @Input() searchMenu: any = [
    { route: '/search/location', label: 'Location' },
    { route: '/search/size', label: 'Company Size' },
    { route: '/search/industry', label: 'Industry' },
    { route: '/search/type', label: 'Company Type' },
    //{ route: '/search/financials', label: 'Financials' },
  ];

  constructor(public router: Router) {}

  ngOnInit(): void {
    this.activeRoute = this.router.url;
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.activeRoute = event.url;
      }
    });
  }

  isActive(route: string) {
    return this.activeRoute.includes(route);
  }

  redirect(route: string) {
    this.router.navigate([`${route}`]);
  }
}
